<template>
    <section id="customers" v-scroll class="py-16 bg-white">
        <div class="container mx-auto px-4">
            <h2 class="text-3xl font-bold text-center mb-12 text-brand">Onze klanten</h2>
            <div class="flex flex-wrap justify-center gap-8">
                <img v-for="(customer, index) in customers" :key="index" :src="customer.logo" :alt="customer.name"
                    class="w-24 h-24 object-contain" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        customers: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped>
/* Add CustomersSection-specific styles if needed */
</style>
